import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useIntl } from "react-intl";
import CustomBreadCrumbs from "../../common/breadcrumbs";
// import UserFilters from "../users/filters";
import { Dropdown } from "primereact/dropdown";
import { GlobalConstants } from "../../../constants";
import LearningObjectReport from "./LearningObjectReport";
import LearningProgramReport from "./LearningProgramReport";
import LearningMilestoneReport from "./LearningMilestoneReport";
import { TextInput } from "../../common/fields";

const Report = ({ labels }) => {
  const navigate = useNavigate();
  const intl = useIntl();
  const [additionalQuery, setAdditionalQuery] = useState({});
  // const [filters, setFilters] = useState([]);
  const [namePattern, setNamePattern] = useState("");
  const [objectNamePattern, setObjectNamePattern] = useState("");
  const [currentReport, setCurrentReport] = useState({
    ...GlobalConstants.REPORTS[0],
    label: intl.formatMessage({
      id: GlobalConstants.REPORTS[0].id,
    }),
  });

  useEffect(() => {
    const timer = setTimeout(() => {
      if (additionalQuery?.namePattern !== namePattern) {
        setAdditionalQuery({
          ...additionalQuery,
          namePattern,
          pageNo: 1,
        });
      }
    }, 500);

    return () => clearTimeout(timer);
  }, [namePattern]);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (additionalQuery?.objectNamePattern !== objectNamePattern) {
        setAdditionalQuery({
          ...additionalQuery,
          objectNamePattern,
          pageNo: 1,
        });
      }
    }, 500);

    return () => clearTimeout(timer);
  }, [objectNamePattern]);

  const getSearchPlaceholder = () => {
    if (currentReport.id === GlobalConstants.LEARNING_OBJECT_REPORTS) {
      return intl.formatMessage({ id: "search_learning_objects" });
    } else if (currentReport.id === GlobalConstants.LEARNING_PROGRAM_REPORTS) {
      return intl.formatMessage({ id: "search_learning_programs" });
    } else if (
      currentReport.id === GlobalConstants.LEARNING_MILESTONE_REPORTS
    ) {
      return intl.formatMessage({ id: "search_learning_milestones" });
    }
  };

  return (
    <div>
      <CustomBreadCrumbs labels={labels} navigate={navigate} />
      <div className="edexlms-page-content">
        <div className="edexlms-page-header">
          <div className="edexlms-page-title">
            {intl.formatMessage({ id: "reports" })}
          </div>
        </div>
        <div
          className="edexlms-page-body"
          style={{
            height: "calc(100vh - 64px - 20px - 45px - 40px - 14px - 40px)",
            overflowY: "scroll",
          }}
        >
          <div className="edexlms-search-filter-bar">
            <Dropdown
              style={{ width: "250px" }}
              value={currentReport}
              options={GlobalConstants.REPORTS.map((item) => ({
                ...item,
                label: intl.formatMessage({ id: item.id }),
              }))}
              onChange={(e) => setCurrentReport(e.value)}
              placeholder={intl.formatMessage({ id: "select_report" })}
            />
            <TextInput
              iconPosition="left"
              icon="pi-search"
              placeholder={intl.formatMessage({ id: "search_users" })}
              input={{
                name: "search_name",
                value: namePattern,
                onChange: (e) => setNamePattern(e.target.value),
              }}
            />
            <TextInput
              iconPosition="left"
              icon="pi-search"
              placeholder={getSearchPlaceholder()}
              input={{
                name: "search_object",
                value: objectNamePattern,
                onChange: (e) => setObjectNamePattern(e.target.value),
              }}
            />
            <Dropdown
              value={additionalQuery.status}
              style={{ width: "200px" }}
              options={GlobalConstants.LEARNING_STATUSES.map((item) => ({
                ...item,
                label: intl.formatMessage({ id: item.id.toLocaleLowerCase() }),
              }))}
              showClear={true}
              onChange={(e) =>
                setAdditionalQuery({
                  ...additionalQuery,
                  status: e.value,
                })
              }
              placeholder={intl.formatMessage({ id: "select_status" })}
            />
            {/* <UserFilters filters={filters} onFilterChange={setFilters} /> */}
          </div>
          {(currentReport.id === GlobalConstants.LEARNING_OBJECT_REPORTS && (
            <LearningObjectReport
              additionalQuery={additionalQuery}
              // filters={filters}
            />
          )) ||
            null}
          {(currentReport.id === GlobalConstants.LEARNING_PROGRAM_REPORTS && (
            <LearningProgramReport
              additionalQuery={additionalQuery}
              // filters={filters}
            />
          )) ||
            null}
          {(currentReport.id === GlobalConstants.LEARNING_MILESTONE_REPORTS && (
            <LearningMilestoneReport
              additionalQuery={additionalQuery}
              // filters={filters}
            />
          )) ||
            null}
        </div>
      </div>
    </div>
  );
};

export default Report;
